<template>
  <div class="aw-page">
    <HeadNav selectedLanguage="en" page="blogs" />
    <main>
      <section class="content-section blog-index">
        <h1>{{ index.title }}</h1>
        <p class="blog-index__lead">{{ index.description }}</p>

        <div class="blog-list">
          <router-link
            v-for="post in posts"
            :key="post.slug"
            class="blog-card"
            :to="{ name: 'blog-post', params: { slug: post.slug } }"
          >
            <img
              class="blog-card__cover"
              :src="post.cover"
              :alt="post.coverAlt || post.title"
              width="480"
              height="270"
              loading="lazy"
            >
            <div class="blog-card__body">
              <h2>{{ post.title }}</h2>
              <time v-if="post.date" class="blog-card__date" :datetime="post.publishedAt">{{ post.date }}</time>
              <p>{{ post.description }}</p>
            </div>
          </router-link>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/site.scss';
import HeadNav from '@/components/HeadNav.vue';
import { blogIndex, blogPosts } from '@/content/blogs';

export default {
  name: 'Blogs',
  components: { HeadNav },
  data() {
    return {
      index: blogIndex,
      posts: blogPosts,
    };
  },
};
</script>
